<template>
  <app-layout
    title="まとめ買い管理">
    <template #header>
      <div class="flex justify-between items-center">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          まとめ買い管理
        </h2>
        <div>
          <button
            class="px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg mr-4 disabled:bg-gray-400 disabled:cursor-not-allowed"
            @click.prevent="onReturnClicked">
            戻る
          </button>
          <button
            class="px-8 py-2 rounded bg-green-500 text-red-50 max-w-max shadow-sm hover:shadow-lg mr-4 disabled:bg-gray-400 disabled:cursor-not-allowed"
            @click.prevent="onCreateClicked">
            新規作成
          </button>
        </div>
      </div>
    </template>
    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="grid grid-cols-3 py-2 text-gray-600">
            <div class="col-span-3">
              PerPage:
              <select
                :value="paginatePerPage"
                class="ml-2 pl-2 rounded border-gray-400"
                @change="onChangedPerPage">
                <option
                  v-for="(n, i) in paginatePerPages"
                  :key="i"
                  :value="n">
                  {{ n }}
                </option>
              </select>
            </div>
          </div>

          <!-- まとめ買い一覧 -->
          <bulk-purchase-list
            :pagination="pagination"
            :limit="limit"
            :current-examination-id="currentExaminationId"
            :current-examination-type="currentExaminationType" />
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { ref, onMounted } from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import BulkPurchaseList from './Partials/BulkPurchaseList.vue'

// @ts-ignore
import route from '@/types/Route'

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  limit: {
    type: String,
    default: '15',
  },
  currentExaminationId: {
    type: String,
    default: '',
  },
  currentExaminationType: {
    type: String,
    default: '',
  },
})

// ページネーション設定
const paginatePerPage = ref(props.limit)
const paginatePerPages = [5, 10, 15, 30, 50, 100]

const onReturnClicked = () => {
  Inertia.get(
    route('examinations',
      {
        examination: props.currentExaminationId,
        examinationType: props.currentExaminationType,
      }),
  )
}

const onChangedPerPage = (e) => {
  Inertia.get(route('bulk_purchase.index', {
    page: '1',
    limit: e.target.value,
    examinationId: props.currentExaminationId,
    examinationType: props.currentExaminationType,
  }))
}

// アクション関数
const onCreateClicked = () => {
  Inertia.get(route('bulk_purchase.create', {
    examinationId: props.currentExaminationId,
    examinationType: props.currentExaminationType,
  }))
}

onMounted(() => {
  paginatePerPage.value = props.pagination.per_page
})
</script>
